export const RichTextToolbar = [
  [{ font: [] }],

  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote'],

  [{ indent: '-1' }, { indent: '+1' }],

  ['clean'],
];
